import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  inactiveMedicationList: [],
};

const inactiveMedicationSlice = createSlice({
  name: 'activeMedicationSlice',
  initialState,
  reducers: {
    setInactiveMedicationList: (state, action) => {
      state.inactiveMedicationList = action.payload.inactivelist;
    },

    clearInactiveMedicationList: state => {
      state.inactiveMedicationList = [];
    },
  },
});

export const { setInactiveMedicationList, clearInactiveMedicationList } =
  inactiveMedicationSlice.actions;

export default inactiveMedicationSlice.reducer;
